import { inject, Injectable } from '@angular/core';
import { FormControl, FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';

import { Audit } from 'src/app/models/audit/audit';
import { UserService } from 'src/app/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuditFormFactory {
  userService = inject(UserService);

  build(formBuilder: NonNullableFormBuilder, auditorEditable: boolean, auditType: string, audit?: Audit): FormGroup {
    const currentDate = new Date();
    return formBuilder.group({
      auditId: new FormControl(audit?.auditId ?? ''),
      auditTitle: new FormControl(audit?.auditTitle ?? ''),
      auditor: new FormControl(audit?.auditor ?? auditType, [Validators.required]),
      reportingYear: new FormControl(audit?.reportingYear ?? currentDate.getFullYear(), [
        Validators.max(currentDate.getFullYear()),
        Validators.required
      ]),
      isSpecialAudit: new FormControl({
        value: audit?.isSpecialAudit,
        disabled: !auditorEditable
      }),
      plant: new FormControl(audit?.plant ?? ''),
      concernsName: new FormControl(audit?.concernsName ?? ''),
      concernsCountry: new FormControl(audit?.concernsCountry ?? ''),
      legalUnit: new FormControl(audit?.legalUnit ?? ''),
      department: new FormControl(audit?.department ?? ''),
      status: new FormControl(audit?.status ?? 'Draft'),
      fileLinkId: new FormControl(audit?.fileLinkId ?? ''),
      assessmentCoordinatorName: new FormControl(audit?.assessmentCoordinatorName ?? ''),
      assessmentCoordinator: new FormControl(
        {
          value: audit?.assessmentCoordinator ? audit.assessmentCoordinator : '',
          disabled: false
        },
        [Validators.required]
      ),
      legalUnitResponsibles: new FormControl(
        {
          value: audit?.legalUnitResponsibles ? audit.legalUnitResponsibles : [],
          disabled: false
        },
        [Validators.required]
      ),
      otherResponsibles: new FormControl(audit?.otherResponsibles ?? []),
      legalUnitResponsiblesNames: new FormControl(audit?.legalUnitResponsiblesNames ?? []),
      otherResponsibleNames: new FormControl(audit?.otherResponsibleNames ?? []),
      emailAddress: new FormControl(audit?.emailAddress ?? ''),
      announcementSentTo: new FormControl(audit?.announcementSentTo ?? []),
      announcementSentOn: new FormControl(audit?.announcementSentOn ?? []),
      announcementSentBy: new FormControl(audit?.announcementSentBy ?? ''),
      authorsBinGen: new FormControl(audit?.authorsBinGen ?? ''),
      assessor: new FormControl(audit?.assessor ?? ''),
      audRole: new FormControl(audit?.audRole ?? ''),
      authorsAuditor: new FormControl(audit?.authorsAuditor ?? ''),
      keypersons: new FormControl(audit?.keypersons ?? []),
      myAttention: new FormControl(audit?.myAttention ?? []),
      readersBusinessGroup: new FormControl(audit?.readersBusinessGroup ?? ''),
      readersLegalUnit: new FormControl(audit?.readersLegalUnit ?? ''),
      readersResponsible: new FormControl(audit?.readersResponsible ?? []),
      isSendStartMail: new FormControl(audit?.isSendStartMail ?? false),
      id: [audit?.id ?? ''],
      createdAt: [audit?.createdAt ?? currentDate],
      modifiedAt: [audit?.modifiedAt ?? ''],
      createdBy: [audit?.createdBy ?? this.userService.userProfile().id],
      modifiedBy: [audit?.modifiedBy ?? ''],
      createdTick: [audit?.createdTick ?? currentDate.getTime()],
      modifiedTick: [audit?.modifiedTick ?? 0],
      newCreatedBy: [''],
      createdByUserId: [audit?.createdByUserId ?? '']
    });
  }
}
